import { faCheck, faLightbulb, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { TranslateService } from '@ngx-translate/core';
import { Status } from 'src/app/shared/models/status.model';
import { CompanyOwned } from '../company/company-models.model';
import { MeasuresCode } from './measures-code.model';

export enum PricebookCodeStatus {
  CONCEPT = 'concept',
  DEFINITIVE = 'definitief',
  ARCHIEF = 'archief',
}

export const pricebookCodeStatuses = (translateService?: TranslateService) =>
  [
    {
      value: PricebookCodeStatus.CONCEPT,
      label: translateService?.instant(`statuses.${PricebookCodeStatus.CONCEPT}`),
      icon: faLightbulb,
      severity: 'concept-status',
    },
    {
      value: PricebookCodeStatus.DEFINITIVE,
      label: translateService?.instant(`statuses.${PricebookCodeStatus.DEFINITIVE}`),
      icon: faCheck,
      severity: 'definitive-status',
    },
    {
      value: PricebookCodeStatus.ARCHIEF,
      label: translateService?.instant(`statuses.${PricebookCodeStatus.ARCHIEF}`),
      icon: faTrash,
      severity: 'archive-status',
    },
  ] as Status<PricebookCodeStatus>[];

@HateoasResource('pricebookcode')
export class PricebookCode extends CompanyOwned {
  public naam!: string;
  public verborgen!: boolean;
  public status!: PricebookCodeStatus;
  public versie!: string;
  public prijspeil!: number;
  public maatregelen!: MeasuresCode[];
}
